import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { PortalRoutes } from '@app/app-routing.module';
import { AuthorizedDataService } from '@app/services/authorized-data/authorized-data.service';

@Component({
  selector: 'trips-page',
  templateUrl: './trips-page.component.html',
  styleUrl: './trips-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TripsPageComponent {
  PortalRoutes = PortalRoutes;

  authorizedDataService = inject(AuthorizedDataService);

  authorizedData$ = this.authorizedDataService.getAuthorizedData();
}
